<script>
import Layout from "../../../../layouts/manage";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";

import { penaltySetting } from "../../../../../services/managements/penaltysettings/penaltysetting.service";

import List from "../../../../../components/list";
import Screen from "../../../../../components/screen";
/* eslint-disable no-console */
/**
 * Contacts-list component
 */
export default {
    extends:Screen,
    page: {
        title: "Penalty Setting",
        meta: [{ name: "description", content: appConfig.description }]
    },
    components: { Layout, PageHeader, List },
    data() {
        return {
        data: {},
        fetchingStats: false,
        title: "Penalty Setting",

        };
    },
    mounted() {
        
        this.loadingData();
    },

    methods: {
        loadingData: function(param = '') {
        this.fetchingStats = false;
            penaltySetting.getList(param)
                .then(response => {
                
                this.fetchingStats = true;
                this.data = response;
            });
        },

        pageNavigate: function(param) {
        this.loadingData(param);
        },

    }
};
</script>

<template>
  <Layout>
    <PageHeader
        :title="$t('manage.penalty-setting.text')" 
    />
    <List v-bind:dataList="data" 
          v-bind:updating="fetchingStats" 
          v-bind:navigate="pageNavigate"
          v-bind:formats="[]"
          v-bind:fields="[ 
            `day_except: ${$t('manage.penalty-setting.except-day')}`,
            `amount: ${$t('manage.penalty-setting.amount')}`,
            `updated_at: ${$t('manage.penalty-setting.last-update')}`,
          ]"
          v-bind:edit="{link: 'manage-setting-penalty-setting-edit'}"
          v-bind:filter="{}"
          
    />      
  </Layout>
</template>